export class SystemCountry {
	id: string;
	name: string;

	constructor() {
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/system-country.ts